/**
 * Usa la función de la librería fetchJsonp para poder evitar el problema de cors
 * En la respuesta hace la llamada a la función "handleResponse" para poder manipular los datos
 */

import fetchJsonp from 'fetch-jsonp'
import sha1 from 'sha1'
import { handleResponse } from './handleResponse'
import { cleanUrlForHash } from './cleanUrlForHash'
import { DICTIONARY_CONFIG } from '../config'

const { dictionaryName, idTag, serviceName } = DICTIONARY_CONFIG

const generateHash = () => sha1(cleanUrlForHash())

export const urlToDictionaryCall = `${serviceName}${idTag}${dictionaryName}${generateHash()}`

export function dictionaryResponse() {
  fetchJsonp(urlToDictionaryCall)
    .then((res) => res.json())
    .catch((error) =>
      console.warn(
        `Esta url no está contemplada en el diccionario o ha ocurrido un error en la llamda ${error}`
      )
    )
    .then((data) => handleResponse(data))
}
